export default "__VITE_ASSET__Dcs9rFJA__"